jQuery(($) => {
  class TabList {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._list = this._element.find('.m-tab-list__list');
      this._tabs = this._element.find('.m-tab-list__tab');
      this._indicator = this._element.find('.m-tab-list__active-indicator');
      this._isTopAligned = this._element.hasClass('m-tab-list--top');

      this._isAutomatic = this._list.data('automatic');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);

      const selectedTab = this._tabs.filter('.a-tab--selected');
      if (selectedTab && selectedTab.length) {
        this.handleActiveIndicator(selectedTab);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._tabs.each((_, tab) => {
        $(tab).on('mousedown', (event) => {
          this.handleTabMousedown(event, tab);
        });

        $(tab).on('keydown', (event) => {
          this.handleTabKeydown(event, tab);
        });
      });

      const debounce = (func) => {
        var timer;
        return function (event) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(func, 100, event);
        };
      };

      $(window).on(
        'resize',
        debounce(() => {
          this.handleActiveIndicator(this._tabs.filter('.a-tab--selected'));
        })
      );
    }

    handleActiveIndicator = (tab) => {
      if (this._isTopAligned && window.innerWidth > 768) {
        setTimeout(() => {
          // Need to wait for next tick to calculate position correctly
          this._indicator.css('left', $(tab).position().left);
          this._indicator.css('width', $(tab).css('width'));
          this._indicator.css('top', '');
          this._indicator.css('height', '');
        }, 100);
      } else {
        this._indicator.css('top', $(tab).position().top);
        this._indicator.css('height', $(tab).css('height'));
        this._indicator.css('left', '');
        this._indicator.css('width', '');
      }
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Select
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabSelect = (tab) => {
      $(tab).tab('handleSelect');
      $(tab).closest('.m-tab-list__item').addClass('m-tab-list__item--selected');

      this.handleActiveIndicator(tab);
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Deselect
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabDeselect = (tab) => {
      $(tab).tab('handleDeselect');
      $(tab).closest('.m-tab-list__item').removeClass('m-tab-list__item--selected');
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabMousedown = (event, tab) => {
      event.preventDefault();

      this.handleTabSelect(tab);

      this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabKeydown = (event, tab) => {
      switch (event.key) {
        case 'Enter':
        case 'spacebar':
        case ' ':
          if (!this._isAutomatic) {
            event.preventDefault();

            this.handleTabSelect(tab);

            this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
          }
          break;

        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();

          const $prevItem = $(tab).closest('.m-tab-list__item').prev();

          if ($prevItem[0]) {
            const $prevTab = $prevItem.find('.m-tab-list__tab');

            $prevTab.focus();

            if (this._isAutomatic) {
              this.handleTabSelect($prevTab);
              this._tabs.not($prevTab).each((_, _tab) => this.handleTabDeselect(_tab));
            }
          }
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();

          const $nextItem = $(tab).closest('.m-tab-list__item').next();

          if ($nextItem[0]) {
            const $nextTab = $nextItem.find('.m-tab-list__tab');

            $nextTab.focus();

            if (this._isAutomatic) {
              this.handleTabSelect($nextTab);
              this._tabs.not($nextTab).each((_, _tab) => this.handleTabDeselect(_tab));
            }
          }
          break;

        case 'Home':
          event.preventDefault();

          const $firstTab = this._list.find('.m-tab-list__item').first().find('.m-tab-list__tab');

          $firstTab.focus();

          if (this._isAutomatic) {
            this.handleTabSelect($firstTab);
            this._tabs.not($firstTab).each((_, _tab) => this.handleTabDeselect(_tab));
          }
          break;

        case 'End':
          event.preventDefault();

          const $lastTab = this._list.find('.m-tab-list__item').last().find('.m-tab-list__tab');

          $lastTab.focus();

          if (this._isAutomatic) {
            this.handleTabSelect($lastTab);
            this._tabs.not($lastTab).each((_, _tab) => this.handleTabDeselect(_tab));
          }
          break;
      }
    };
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.tab_list = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].tab_list = new TabList(_[i], opt);
      else ret = _[i].tab_list[opt].apply(_[i].tab_list, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-tab-list').tab_list();
});
